// extracted by mini-css-extract-plugin
export default {"popper":"popper_popper__aXemi","arrow":"popper_arrow__w5cBM"};